import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src="/logo.jpeg" alt="Adiyogi Natural Farms" className="footer-logo" />
          <span>Adiyogi Natural Farms</span>
        </div>
        <p className="footer-tagline">🌿 Pure 🌿 Natural 🌿 From Our Farm to Your Table 🌿</p>
        <div className="footer-links">
          {['#hero','#products','#customers','#gallery','#location'].map((href) => (
            <a key={href} href={href}>{href.replace('#','').charAt(0).toUpperCase() + href.slice(2)}</a>
          ))}
        </div>
        <p className="footer-copy">© {new Date().getFullYear()} AdiYogi Natural Farm. All rights reserved.</p>
      </div>
    </footer>
  );
}
